<template>
  <div>
    <v-col cols="12">
      <v-alert type="error" v-if="informText != ''">
        {{ informText }}
      </v-alert>

      <v-data-table
        :headers="headers"
        :items="listPayslip"
        class="elevation-1"
        :loading="loading"
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Tìm kiếm nhân viên"
              single-line
              hide-details
              class="shrink mx-4"
              title="Tìm kiếm"
            ></v-text-field>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-row>
              <v-col cols="2">
                <v-menu
                  ref="report_month"
                  v-model="report_month"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  persistent
                  offset-y
                  min-width="290px"
                  style="z-index: 3"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="report_month_data"
                      label="Chọn tháng"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      style="margin-top: 15px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="report_month_data"
                    type="month"
                    scrollable
                    v-if="report_month"
                    @change="filterData"
                  ></v-date-picker>
                  <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
                </v-menu>
              </v-col>
              <v-col cols="1">
                <v-btn
                  color="orange"
                  @click="
                    report_month_data = '';
                    filterData();
                  "
                  dark
                  style="margin-top: 15px"
                  >CLEAR</v-btn
                >
              </v-col>
              <v-col style="text-align: left; margin-top: 20px">
                <b>Tổng lương thực lĩnh {{ report_month_data }}: </b>
                <template v-if="sum_luong_thuc_linh">
                  {{
                    sum_luong_thuc_linh.toLocaleString("vi-VN", {
                      style: "currency",
                      currency: "VND",
                    })
                  }}
                </template>
                <template v-else> 0 </template>
                -
                <b>Tổng thưởng thực lĩnh {{ report_month_data }}: </b>
                <template v-if="sum_thuong_thuc_linh">
                  {{
                    sum_thuong_thuc_linh.toLocaleString("vi-VN", {
                      style: "currency",
                      currency: "VND",
                    })
                  }}
                </template>
                <template v-else> 0 </template>
                -
                <b>Tổng thu nhập {{ report_month_data }}: </b>
                <template v-if="sum_tong_thu_nhap">
                  {{
                    sum_tong_thu_nhap.toLocaleString("vi-VN", {
                      style: "currency",
                      currency: "VND",
                    })
                  }}
                </template>
                <template v-else> 0 </template>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:item.date="{ item }">
          {{ item.month }}/{{ item.year }}
        </template>
        <template v-slot:item.luong_thuc_linh="{ item }">
          <template v-if="item.luong_thuc_linh">
            {{
              item.luong_thuc_linh.toLocaleString("vi-VN", {
                style: "currency",
                currency: "VND",
              })
            }}
          </template>
          <template v-else> 0 </template>
        </template>
        <template v-slot:item.thuong_thuc_linh="{ item }">
          <template v-if="item.thuong_thuc_linh">
            {{
              item.thuong_thuc_linh.toLocaleString("vi-VN", {
                style: "currency",
                currency: "VND",
              })
            }}
          </template>
          <template v-else> 0 </template>
        </template>
        <template v-slot:item.tong_thu_nhap="{ item }">
          <template v-if="item.tong_thu_nhap">
            {{
              item.tong_thu_nhap.toLocaleString("vi-VN", {
                style: "currency",
                currency: "VND",
              })
            }}
          </template>
          <template v-else> 0 </template>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="primary"
            medium
            @click="
              selectedItem = item._id;
              dialogDetail = !dialogDetail;
            "
            v-if="roles.read_payslip"
          >
            Xem chi tiết
          </v-btn>
        </template>
      </v-data-table>
    </v-col>

    <BaseDialog :active.sync="dialogDetail" dialog_name="Payslip Detail">
      <Detail :data="selectedItem" />
    </BaseDialog>
  </div>
</template>

<script>
import axios from "axios";
//import moment from "moment-timezone";
import Amplify, { Auth } from "aws-amplify";
import Detail from "./c-dialog-payslip-detail";
import BaseDialog from "../Common/c-base-dialog";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "PayslipList",

  components: {
    Detail,
    BaseDialog,
  },

  created() {
    this.$root.$refs.payslips = this;
  },

  data: () => ({
    report_month: "",
    report_month_data: "",
    search: "",
    listPayslip: [],
    listPayslipOrigin: [],
    loading: false,
    informText: "",
    selectedItem: "",
    dialogDetail: false,
    roles: [],
    headers: [
      {
        text: "Nhân viên",
        align: "start",
        value: "name",
      },
      { text: "Tháng", value: "date" },
      { text: "Lương Thực Lĩnh", value: "luong_thuc_linh" },
      { text: "Thưởng Thực Lĩnh", value: "thuong_thuc_linh" },
      { text: "Tổng Thu Nhập", value: "tong_thu_nhap" },
      { text: "Chức vụ", value: "roles" },
      { text: "Chi Tiết", value: "actions" },
    ],
    sum_luong_thuc_linh: 0,
    sum_thuong_thuc_linh: 0,
    sum_tong_thu_nhap: 0,
  }),

  methods: {
    turnOffDialog() {
      this.dialogDetail = false;
    },

    async loadData() {
      this.loading = true;
      this.listPayslip = [];
      var currentSession = await this.$root.$refs.App.currentSession(
        "payslip-loadData"
      );
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "payslips", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("payslip Response: ", response);
            if (response.data.error_message == "") {
              this.listPayslip = response.data.data.payslips;
              this.listPayslipOrigin = JSON.parse(
                JSON.stringify(this.listPayslip)
              );
            } else {
              this.informText = response.data.error_message;
            }
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession payslip-loadData-undefined: ",
          currentSession
        );
      }
      this.loading = false;
    },

    filterData() {
      this.sum_luong_thuc_linh = 0;
      this.sum_thuong_thuc_linh = 0;
      this.sum_tong_thu_nhap = 0;

      if (this.report_month_data != "") {
        this.listPayslip = [];
        var time = this.report_month_data.split("-");
        var year = time[0];
        var month = time[1];

        for (const i of this.listPayslipOrigin) {
          if (i.month == month && i.year == year) {
            this.listPayslip.push(i);
          }
        }

        for (const j of this.listPayslip) {
          this.sum_luong_thuc_linh += j.luong_thuc_linh;
          this.sum_thuong_thuc_linh += j.thuong_thuc_linh;
          this.sum_tong_thu_nhap += j.tong_thu_nhap;
        }
      } else {
        this.listPayslip = JSON.parse(JSON.stringify(this.listPayslipOrigin));
      }
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("payslip");
    if (this.roles.list_payslips) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      await this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style lang="scss" scoped>
</style>